import React, { useState } from 'react';
import classNames from 'classnames';
import PasswordToolTip from './PasswordToolTip';
import useValidateValue, { INVALID_CLASS } from '../../../../hooks/useValidationHook';
import { IInputProps } from '../../../../../interfaces';
import styles from './Input.module.css';

const Input: React.FunctionComponent<IInputProps> = (props) => {
  const {
    name,
    value,
    type,
    label,
    handleInput,
    hasMargin,
    maxLength,
    hidden,
    hiddenLabel,
    errorMessage,
    dataRecurly,
    onBlur,
  } = props;
  const [showPasswordToolTip, setShowPasswordToolTip] = useState(false);
  const { validationClass, validateValue } = useValidateValue();
  const [hasBeenValidated, setHasBeenValidated] = useState(false);
  // We need to remove or use when updating form hadling logic
  const emailIsNotUnique = false; // !prospect.isEmailUnique && name === 'email';

  const togglePasswordTooltip = (showToolTip: boolean) => {
    if (name === 'password') {
      setShowPasswordToolTip(showToolTip);
    }
  };

  const handleValidationOnChange = (inputValue: string) => {
    if (hasBeenValidated) {
      validateValue(name, inputValue.trim());
    }
  };

  const handleValidationOnBlur = (inputValue: string) => {
    if (!hasBeenValidated) {
      setHasBeenValidated(true);
      validateValue(name, inputValue.trim());
    }
  };

  return (
    <div
      className={classNames(styles.inputWrapper, {
        [styles.inputContainerMargin]: hasMargin,
      })}
      hidden={hidden}
    >
      <div className={styles.inputContainer}>
        {showPasswordToolTip && name === 'password' && <PasswordToolTip password={value} />}
        <label htmlFor={name} className={styles.inputLabel}>
          {hiddenLabel ? '' : label}
          <input
            id={name}
            className={classNames(
              styles.input,
              { [INVALID_CLASS]: emailIsNotUnique },
              { [validationClass]: !emailIsNotUnique }
            )}
            type={type}
            name={name}
            maxLength={maxLength}
            placeholder={label}
            value={value}
            autoComplete={name === 'password' ? 'new-password' : ''}
            data-recurly={dataRecurly}
            data-testid={name}
            onChange={(e) => {
              handleValidationOnChange(e.target.value);
              handleInput(e);
            }}
            onFocus={() => togglePasswordTooltip(true)}
            onBlur={(e) => {
              togglePasswordTooltip(false);
              handleValidationOnBlur(e.target.value);
              if (onBlur) onBlur(e);
            }}
          />
          {validationClass === INVALID_CLASS && !showPasswordToolTip && (
            <p className={styles.inputError} data-testid={`error-${name}`}>
              {emailIsNotUnique ? 'This email has already been registered.' : errorMessage}
            </p>
          )}
        </label>
      </div>
    </div>
  );
};

export default Input;
